import { Component, OnInit, Inject } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MajorFooter } from '../../core/constants/major-footer.constant';
import { ParmedFooter } from '../../core/constants/parmed-footer.constant';
import { Footer } from '../../shared/models/footer';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CacheConstant } from '../../core/constants/app.constant';
import { BaseComponent } from '../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfigService } from '../../core/services/init/app-config.service';


@Component({
  selector: 'par-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent extends BaseComponent implements  OnInit {
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  entity =  `${this.websiteName +'Footer'}`;
  footerData : Footer;
  constructor(
    public dialogRef: MatDialogRef<HelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private overlayContainer: OverlayContainer,
    private cache: AppCacheService,
    deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService
  ) {
    super(deviceDetectorService, cache, appConfig);
    this.footerData = super.getFooterData();
  }

  ngOnInit() {}

  onClose() {
    this.dialogRef.close();
  }
}
